<template>

    <div class="visualizatioon">
        <h1 class="page-header">Radviz Vizualization <small>Iris dataset</small></h1>

        <div class="panel-inverse">
        <div class="panel-heading">Radviz Vizualization</div>
        <div class="panel-body bg-white text-black">
             <button type="button"   v-on:click="funkcia()" class="btn btn-info m-r-5 m-b-5">Prekresli</button>
             <div class="container"></div>
            <div id="tooltip"></div>
        </div>
        </div> 
    </div>
</template>

<script src=""></script>
<script>
var dimensions = ["sepalLength", "sepalWidth", "petalLength", "petalWidth"];

export default {
  data() {
    return {
      name: "Radviz"
    };
  },
  created() {
   
  },
  mounted() {
      let radvizScript = document.createElement("script");
    radvizScript.setAttribute(
      "src",
      "https://rawgit.com/biovisualize/radviz/master/radviz-min.js"
    );
    document.head.appendChild(radvizScript);
  }, 
   methods: {
    funkcia() {
    //   let sc = document.createElement("script");
    //sc.setAttribute("src", "https://d3js.org/d3.v3.min.js");
   // document.head.appendChild(sc);
    let radvizScript = document.createElement("script");
    radvizScript.setAttribute(
      "src",
      "https://rawgit.com/biovisualize/radviz/master/radviz-min.js"
    );
    document.head.appendChild(radvizScript);
     var radviz = radvizComponent().config({
      el: document.querySelector(".container"),
      colorAccessor: function(d) {
        return d["species"];
      },
      dimensions: dimensions,
      size: 500,
      margin: 100,
      useRepulsion: true,
      drawLinks: true,
      tooltipFormatter: function(d) {
        return (
          "<h1>" +
          d.species +
          "</h1>" +
          dimensions
            .map(function(dB) {
              return dB + ": " + d[dB];
            })
            .join("<br />")
        );
      }
    });
    d3.json(
      "https://rawgit.com/biovisualize/radviz/master/data/iris.json",
      function(error, data) {
        console.log(data);
        radviz.render(data);
      }
    );
    }
  }
};
</script> 


<style>
.visualizatioon > .panel {
    stroke: black;
    fill: white;
}

.bg {
  fill: white;
}

.link {
  stroke: silver;
  stroke-opacity: 0.05;
}

.dot {
  fill-opacity: 0.5;
}

.label-node {
  fill: silver;
}

.active {
  stroke: black;
}

.label {
  fill: gray;
  pointer-events: none;
}

#tooltip {
  font-size: 12px;
  margin-top: 22px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
}

#tooltip h1 {
  font-size: 14px;
  margin: 0;
}
</style> 